import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from "./Components/Navbar";
// import Navbar from "./Components/Navbar2";
import Home from "./Components/Home";
// import Resources from './Components/Resources';
import Industries from './Components/Industries';
import About from "./Components/About";
import Contact from "./Components/Contact";
import Footer from "./Components/Footer";
import Cargo from './Components/Cargo';
import Vessel from './Components/Vessel';
import Global from './Components/Global';
import Logistics from './Components/Logistics';
import Import from './Components/Import';
import Customs from './Components/Customs';
import AirChartering from './Components/AirChartering';
import Bags from './Components/Bags';
import Holiday from './Components/Holiday';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import logo from './Img/whatsapp_logo.png';
import logo from './Img/Contact Icons/whatsapp.png';
import ScrollTop from './Components/ScrollTop';

function App() {
  return (
    <div className="background" style={{ fontFamily: "'Roboto Slab',Kode Mono, monospace" }}>
      <Router>
        <ScrollTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/Resources" element={<Resources />} /> */}
          <Route path="/Industries" element={<Industries/>} />
          <Route path="/About" element={<About />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Cargo" element={<Cargo />} />
          <Route path="/Vessel" element={<Vessel />} />
          <Route path="/Global" element={<Global />} />
          <Route path="/Logistics" element={<Logistics />} />
          <Route path="/Import" element={<Import />} />
          <Route path="/Customs" element={<Customs />} />
          <Route path="/AirChartering" element={<AirChartering />} />
          <Route path="/Bags" element={<Bags />} />
          <Route path="/Holiday" element={<Holiday />} />
        </Routes>
        <Footer />
      </Router>
      <div
        className="fixed-bottom p-3"
        style={{
          zIndex: 6,
          right: "20px",
          left: "auto",
        }}
      >
        <a
          href="https://wa.me/+971503713027?"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat with us on WhatsApp"
          style={{
            display: "inline-block",
            borderRadius: "50%",
            boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
            transition: "transform 0.2s ease-in-out",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <img src={logo} alt="WhatsApp Logo" width={50} height={50} />
        </a>
      </div>
    </div>
  );
}
export default App;